<template>
  <el-main class="page-content-margin-unset">
    <h3>物流信息</h3>
    <!-- 表格 -->
    <el-table
      border
      class="dk-li"
      :data="tableData">
      <el-table-column
        prop="logistics_num"
        label="物流单号"/>
      <el-table-column
        prop="create_time"
        label="发货时间"/>
      <el-table-column
        prop="origin"
        label="出发地"/>
      <el-table-column
        prop="destination"
        label="目的地"/>
      <el-table-column
        prop="path_type"
        label="线路类型"/>
    </el-table>
    <h3>对应商品订单</h3>
    <!-- 表格 -->
    <el-table
      border
      class="dk-li"
      :data="logisticsOrderList">
      <el-table-column
        prop="order_id"
        label="订单号"/>
      <el-table-column
        prop="create_time"
        label="创建时间"/>
      <el-table-column
        prop="name"
        label="用户昵称"/>
      <el-table-column
        prop="mobile"
        label="手机号"/>
      <el-table-column
        prop="status"
        label="订单状态"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toDetailClick(scope.row)">
            详 情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentOrderChange"
        :current-page.sync="bodyOrder.page_index"
        :page-size="bodyOrder.page_size"
        layout="prev, pager, next"
        :total="totalOrder"/>
    </div>
<!--    <h3>对应商品兑换订单</h3>-->
<!--    &lt;!&ndash; 表格 &ndash;&gt;-->
<!--    <el-table-->
<!--      border-->
<!--      class="dk-li"-->
<!--      :data="logisticsPointOrderList">-->
<!--      <el-table-column-->
<!--        prop="order_id"-->
<!--        label="订单号"/>-->
<!--      <el-table-column-->
<!--        prop="create_time"-->
<!--        label="创建时间"/>-->
<!--      <el-table-column-->
<!--        prop="name"-->
<!--        label="用户昵称"/>-->
<!--      <el-table-column-->
<!--        prop="mobile"-->
<!--        label="手机号"/>-->
<!--      <el-table-column-->
<!--        prop="status"-->
<!--        label="订单状态"/>-->
<!--      <el-table-column-->
<!--        fixed="right"-->
<!--        label="管理"-->
<!--        width="330">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button-->
<!--            size="mini"-->
<!--            type="primary"-->
<!--            class="mini-el-button"-->
<!--            @click="event().toDetailClick(scope.row)">-->
<!--            详 情-->
<!--          </el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
<!--    &lt;!&ndash; 分页组件 &ndash;&gt;-->
<!--    <div>-->
<!--      <el-pagination-->
<!--        background-->
<!--        @current-change="handleCurrentOrderPointChange"-->
<!--        :current-page.sync="bodyOrderPoint.page_index"-->
<!--        :page-size="bodyOrderPoint.page_size"-->
<!--        layout="prev, pager, next"-->
<!--        :total="totalPointOrder"/>-->
<!--    </div>-->
    <h3>物流动态</h3>
    <!-- 表格 -->
    <el-table
      border
      class="dk-li"
      :data="logisticsArr">
      <el-table-column
        prop="time"
        label="时间"/>
      <el-table-column
        prop="address"
        label="当前状态"/>
      <el-table-column
        fixed="right"
        label="管理"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().onEditClick(scope.row)">
            编 辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            class="mini-el-button"
            @click="event().onDelClick(scope.row.uuid)">
            删 除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button
      type="primary"
      class="mini-el-button"
      @click="event().toBrackClick()">
      返 回
    </el-button>


    <!-- 更新物流 -->
    <el-dialog
      :title="updateTitle"
      width="720px"
      :visible.sync="updateDialog">
      <el-form
        :model="addBody"
        label-position="left"
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item
          label="时 间"
          prop="time">
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="addBody.time"
            type="datetime"
            placeholder="选择日期时间"/>
        </el-form-item>
        <el-form-item
          label="途径点"
          prop="point">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="addBody.point"
            :fetch-suggestions="searchDelivery"
            placeholder="请输入内容"
            @select="handleSelect">
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"/>
            <template slot-scope="{ item }">
              <div class="name">{{ item.title }}</div>
              <span class="addr">{{ item.address }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item
          label="当前状态"
          prop="address">
          <el-select v-model="addBody.address" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
<!--          <el-input-->
<!--            class="dk-input"-->
<!--            type="textarea"-->
<!--            :autosize="{ minRows: 2, maxRows: 4}"-->
<!--            v-model="addBody.address"/>-->
        </el-form-item>
      </el-form>
      <div
        id="allmap"
        style="width:100%;height:400px"/>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="updateDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureClick('ruleForm2')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
// eslint-disable-next-line
import BMap from 'BMap';
import {
  getLogisticsDetail, getLogisticsOrderDetail, getLogisticsPointOrderDetail, editLogistics,
  deleteLogistics,
} from '../../api/logistics'
import { imgDomain } from '../../configs/env'
import commoonFunction from '../../mixins/common'

export default {
  mixins: [commoonFunction],
  data() {
    return {
      imgDomain,
      updateTitle: '新增',
      updateDialog: false,
      tableData: [],
      // 商品
      bodyOrder: {
        uuid: this.$route.query.uuid,
        page_index: 1,
        page_size: 10,
      },
      logisticsOrderList: [],
      totalOrder: 0,
      // 商品兑换
      bodyOrderPoint: {
        uuid: this.$route.query.uuid,
        page_index: 1,
        page_size: 10,
      },
      logisticsPointOrderList: [],
      totalPointOrder: 0,
      // 物流
      logisticsArr: [],
      // 编辑物流
      addBody: {
        uuid: '',
        address: '',
        time: '',
        coordinate: {
          lat: 0,
          long: 0,
        },
        point: '',
      },
      restaurants: [],
      rules2: {
        address: [
          { required: true, message: '请输入当前状态', trigger: 'blur' },
        ],
        time: [
          { required: true, message: '请输入时间', trigger: 'blur' },
        ],
        point: [
          { required: true, message: '请输入途径点', trigger: 'blur' },
        ],
      },
      options: [{
        value: '已发货',
        label: '已发货'
      }, {
        value: '运输中',
        label: '运输中'
      }, {
        value: '派件中',
        label: '派件中'
      }, {
        value: '待取件',
        label: '待取件'
      }, {
        value: '已签收',
        label: '已签收'
      }],
    };
  },

  components: {
  },
  created() {
    this.network().getLogisticsDetail()
    this.network().getLogisticsOrderDetail()
    this.network().getLogisticsPointOrderDetail()
  },
  methods: {
    createMap() {
      // 百度地图API功能
      this.map = new BMap.Map('allmap'); // 创建Map实例
      this.map.centerAndZoom(new BMap.Point(
        this.addBody.coordinate.long,
        this.addBody.coordinate.lat,
      ),
      13); // 初始化地图,设置中心点坐标和地图级别
      // map.setCurrentCity('北京'); // 设置地图显示的城市 此项是必须设置的
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
    },
    searchDelivery(queryString, cb) {
      const local = new BMap.LocalSearch(this.map);
      local.search(this.addBody.point);
      setTimeout(() => {
        this.querySearch(queryString, cb, local.getResults() || { Gq: [] })
      }, 1000);
    },
    querySearch(queryString, cb, { Hr: address }) {
      const { restaurants } = this;
      const results = queryString ? address : restaurants;
      cb(results);
    },
    handleSelect({ title, point: { lat, lng } }) {
      this.addBody.point = title
      this.addBody.coordinate.lat = lat
      this.addBody.coordinate.long = lng
      this.panTo(lat, lng)
    },
    panTo(lat, lng) {
      this.map.panTo(new BMap.Point(lng, lat));
      this.map.setZoom(20);
    },
    handleCurrentOrderChange() {
      this.network().getLogisticsOrderDetail()
    },
    handleCurrentOrderPointChange() {
      this.network().getLogisticsPointOrderDetail()
    },
    event() {
      return {
        toAddClick: () => {
          this.$router.push({ path: '/logistics-management/add' })
        },
        onUpdateClick: () => {
          this.updateDialog = true
        },
        toBrackClick: () => {
          this.$router.go(-1)
        },
        onEditClick: (row) => {
          this.addBody = row
          this.updateDialog = true
          this.$nextTick(() => {
            this.createMap()
          })
        },
        onDelClick: (uuid) => {
          this.isDel('确定删除该物流动态, 是否继续?', 'deleteLogistics', uuid)
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // 调接口
              this.network().editLogistics()
            } else {
              console.log('error submit!!');
            }
          });
        },
      }
    },
    network() {
      return {
        getLogisticsDetail: async () => {
          const { status, data } = await getLogisticsDetail(this.$route.query.uuid)
          if (status !== 200) return
          this.tableData = [data]
          this.logisticsArr = data.detail
        },
        getLogisticsOrderDetail: async () => {
          const { status, data } = await getLogisticsOrderDetail(this.bodyOrder)
          if (status !== 200) return
          this.logisticsOrderList = data.data
          this.totalOrder = data.total
        },
        getLogisticsPointOrderDetail: async () => {
          const { status, data } = await getLogisticsPointOrderDetail(this.bodyOrderPoint)
          if (status !== 200) return
          this.logisticsPointOrderList = data.data
          this.totalPointOrder = data.total
        },
        editLogistics: async () => {
          const { status } = await editLogistics(this.addBody)
          if (status !== 200) return
          this.network().getLogisticsDetail()
          this.$notify({
            title: '编辑成功',
            message: '便就物流动态成功',
            type: 'success',
          });
          this.updateDialog = false
        },
        deleteLogistics: async (uuid) => {
          const { status } = await deleteLogistics(uuid)
          if (status !== 200) return
          this.network().getLogisticsDetail()
          this.$notify({
            title: '删除成功',
            message: '删除物流动态成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-autocomplete-suggestion li span {
    font-size: 12px;
    color: #b4b4b4;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/logistics/detail.vue